import { styled } from '@clickcease/cc-client-components-lib'

export const InvoicesTableModalStyled = styled('div', {
  width: '130vh',
  height: '70vh',
  padding: '0px 16px',

  ['.ok-button']: {
    width: '50px',
    height: '30px',
  },
})
